const invertedMessages = {
  'NEW: Classify your users for better security insights and management.':
    'external.begin.rules.banner.title',
  'We’ll can help you define which types of users pose higher-risk to your business and tools to manage your security posture.':
    'external.begin.rules.banner.description',
  'Begin Identity Classification': 'external.begin.rules.banner.button',
} as const;

export default invertedMessages;
